import { render } from "./auto-renew-failed.vue?vue&type=template&id=48906fd3&scoped=true&ts=true"
import script from "./auto-renew-failed.vue?vue&type=script&lang=ts"
export * from "./auto-renew-failed.vue?vue&type=script&lang=ts"

import "./auto-renew-failed.vue?vue&type=style&index=0&id=48906fd3&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48906fd3"]])

export default __exports__